/*
 * Minimal pointer-based drag, replacing jQuery UI draggable + touch-punch.
 *
 * Pointer events cover mouse, touch and pen in one code path, so the old
 * touch-punch shim is no longer needed.
 */
export function draggable(element, { containment, onDrag, onStop } = {}) {
  let pointerId = null;
  let startX = 0;
  let startY = 0;
  let originLeft = 0;
  let originTop = 0;

  const clamp = (value, min, max) => (min > max ? value : Math.min(Math.max(value, min), max));

  const onPointerDown = (event) => {
    if (pointerId !== null) {
      return;
    }

    pointerId = event.pointerId;
    startX = event.clientX;
    startY = event.clientY;
    originLeft = parseInt(getComputedStyle(element).left, 10) || 0;
    originTop = parseInt(getComputedStyle(element).top, 10) || 0;

    element.setPointerCapture(pointerId);
  };

  const onPointerMove = (event) => {
    if (event.pointerId !== pointerId) {
      return;
    }

    let left = originLeft + (event.clientX - startX);
    let top = originTop + (event.clientY - startY);

    if (containment) {
      const { left: minLeft, top: minTop, right: maxLeft, bottom: maxTop } = containment();
      left = clamp(left, minLeft, maxLeft);
      top = clamp(top, minTop, maxTop);
    }

    element.style.left = `${left}px`;
    element.style.top = `${top}px`;

    onDrag?.({ left, top });
  };

  const onPointerUp = (event) => {
    if (event.pointerId !== pointerId) {
      return;
    }

    element.releasePointerCapture(pointerId);
    pointerId = null;
    onStop?.();
  };

  element.style.touchAction = "none";
  element.addEventListener("pointerdown", onPointerDown);
  element.addEventListener("pointermove", onPointerMove);
  element.addEventListener("pointerup", onPointerUp);
  element.addEventListener("pointercancel", onPointerUp);

  return function destroy() {
    element.removeEventListener("pointerdown", onPointerDown);
    element.removeEventListener("pointermove", onPointerMove);
    element.removeEventListener("pointerup", onPointerUp);
    element.removeEventListener("pointercancel", onPointerUp);
  };
}
